/*
 * Author: Dw
 * File Created: Thursday, 24-08-08 04:56 pm
 * Last Modified: Monday, 24-10-28 10:47 am, by Roger
 */

import styled from '@emotion/styled';
import type { ButtonProps } from '@mui/material';
import { Button } from '@mui/material';
interface GradientButtonProps extends ButtonProps {
  fill?: boolean;
}
const GradientButton = styled(Button, {
  shouldForwardProp: prop => prop !== 'fill'
})<GradientButtonProps>(({
  theme,
  fill
}) => ({
  position: 'relative',
  background: fill ? 'linear-gradient(90deg, #652D90 0%, #E73593 60%, #F05F65 100%)' : 'transparent',
  border: fill ? 'none' : '1px solid transparent',
  color: '#fff',
  zIndex: 1,
  // cursor: 'default',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    borderRadius: 'inherit',
    padding: '1px',
    background: 'linear-gradient(90deg, #652D90 0%, #E73593 60%, #F05F65 100%)',
    WebkitMask: fill ? 'none' : 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: fill ? 'none' : 'xor',
    maskComposite: fill ? 'none' : 'exclude',
    zIndex: -1
  },
  '&:hover': {
    // backgroundColor: fill ? 'linear-gradient(90deg, #652D90 0%, #E73593 60%, #F05F65 100%)' : 'rgba(255, 255, 255, 0.1)',
    color: '#fff',
    background: 'transparent'
  }
}));
export default GradientButton;